export default __webpack_public_path__ + "static/media/contact_background-min.17129cb7.jpg";